import * as React from "react";
const SvgFiRrUserGear = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-gear_svg__a)">
      <path
        fill="#062147"
        d="M15 6c0-3.309-2.691-6-6-6S3 2.691 3 6s2.691 6 6 6 6-2.691 6-6m-6 4c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m-.008 4.938a1 1 0 0 1-.869 1.116A7.006 7.006 0 0 0 1.999 23a1 1 0 0 1-2 0c0-4.531 3.386-8.37 7.876-8.93a1.003 1.003 0 0 1 1.116.869zm13.704 4.195-.974-.562A5 5 0 0 0 22 16.999c0-.553-.111-1.075-.278-1.572l.974-.562a1 1 0 0 0-1-1.732l-.973.562A4.97 4.97 0 0 0 18 12.101V11a1 1 0 0 0-2 0v1.101a5 5 0 0 0-2.723 1.594l-.973-.562a1 1 0 0 0-1 1.732l.974.562A5 5 0 0 0 12 16.999c0 .553.111 1.075.278 1.572l-.974.562a1 1 0 0 0 1 1.732l.973-.562A4.97 4.97 0 0 0 16 21.897v1.101a1 1 0 0 0 2 0v-1.101a5 5 0 0 0 2.723-1.594l.973.562a.997.997 0 0 0 1.366-.366 1 1 0 0 0-.366-1.366M17 19.999c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-gear_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserGear;
